import React, { FC, ReactNode } from 'react'

import TrackVisibility from 'react-on-screen'

/**
 * Only renders children when they are in the viewport
 * @param children to render
 * @param everyTime unmount when not in viewport, and mount again when in viewport
 * @returns {JSX.Element}
 * @constructor
 */
export interface InViewportProps {
  children: ReactNode
  everyTime?: boolean
}

export const InViewport: FC<InViewportProps> = ({ children, everyTime }) => (
  <TrackVisibility once={!everyTime}>
    {({ isVisible }) => {
      if (isVisible) return children
      return null
    }}
  </TrackVisibility>
)

export default InViewport
